import axios from "axios"
function load_data(model_name, mtquery, search_url_prefix = '/api/data') {
    let { page, pageSize, search, filters, ...otherqry } = mtquery
    return axios.post(
        process.env.REACT_APP_API_URL + `${search_url_prefix}/${model_name}/search`,
        { page, page_size: pageSize, query: search, filters, ...otherqry }
    )
}


function load_meta(model_name, search_url_prefix = '/api/data') {
    return axios.get(
        process.env.REACT_APP_API_URL + `${search_url_prefix}/${model_name}/get_meta`
    )
}

function add_data(model_name, data, url_prefix = '/api/data') {
    return axios.put(
        process.env.REACT_APP_API_URL + `${url_prefix}/${model_name}/new`,
        data
    )
}


function get_data(model_name, id, url_prefix = '/api/data') {
    return axios.get(
        process.env.REACT_APP_API_URL + `${url_prefix}/${model_name}/${id}`
    )
        .then(resp => resp.data)
}



function update_data(model_name, id, data, url_prefix = '/api/data') {
    return axios.post(
        process.env.REACT_APP_API_URL + `${url_prefix}/${model_name}/${id}`,
        data
    )
        .then(resp => resp.data)
}




function delete_data(model_name, id, url_prefix = '/api/data') {
    return axios.delete(
        process.env.REACT_APP_API_URL + `${url_prefix}/${model_name}/${id}`
    )
        .then(resp => resp.data)
}



export {
    add_data,
    load_data,
    get_data,
    update_data,
    delete_data,
    load_meta,
}